import { useState } from "react";
import { useNavigate } from "react-router";
import { Button } from "nazare-ui/primitives";
import { PlatformModal } from "../../../../platform-modal";
import { useFailedStepRetryPlan, useRetryFailedWorkflowSteps, type RunSummary } from "../../../../workflows-api";
import styles from "./run-detail.module.css";

export function RetryFailedStepsControl({ run }: { run: RunSummary }) {
  const plan = useFailedStepRetryPlan(run.runId, ["failed", "completed"].includes(run.status));
  const retry = useRetryFailedWorkflowSteps();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const eligible = !!plan.data?.eligible;
  if (!eligible && !open) return null;

  return (
    <>
      {eligible && (
        <Button className={styles.workflowButton} variant="outline" onClick={() => {
          retry.reset();
          setOpen(true);
        }}>
          Retry failed steps ({plan.data?.failedStepCount.toLocaleString("en-GB")})
        </Button>
      )}
      {open && (
        <PlatformModal
          title="Retry failed steps?"
          description={`${(plan.data?.completedStepCount ?? 0).toLocaleString("en-GB")} completed steps will be reused. A new attempt retries failed steps and continues any work that depends on them, using the same input.`}
          confirmLabel="Retry failed steps"
          pendingLabel="Starting retry…"
          pending={retry.isPending}
          confirmDisabled={!eligible}
          error={retry.error?.message ?? (!eligible ? plan.data?.reason ?? "Retry eligibility could not be confirmed." : null)}
          onClose={() => {
            if (!retry.isPending) setOpen(false);
          }}
          onConfirm={() => retry.mutate(run.runId, {
            onSuccess: (result) => {
              setOpen(false);
              navigate(`/workflows/runs/${encodeURIComponent(result.runId)}`);
            },
          })}
        />
      )}
    </>
  );
}
